export default "__VITE_ASSET__DAyfuEb___"